import { render, staticRenderFns } from "./AlertBarInflationAdjustments.vue?vue&type=template&id=bbb4ccae&"
import script from "./AlertBarInflationAdjustments.vue?vue&type=script&lang=js&"
export * from "./AlertBarInflationAdjustments.vue?vue&type=script&lang=js&"
import style0 from "./AlertBarInflationAdjustments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports